import React from "react";
import Brands from "../components/app/home/Brands";
import ExpertiseAndExpericence from "../components/app/home/ExpertiseAndExpericence";
import OurMisson from "../components/app/home/OurMisson";
import WorkwithUs from "../components/app/home/WorkwithUs";
import EarlyAccess from "../components/app/common/EarlyAccess";
import HomeMarquee from "../components/app/home/HomeMarquee";
import { BlurFade } from "../components/app/BlurFade";
const HomePage: React.FC = () => {
  return (
    <div>
      <section
        className="min-h-[70vh] md:min-h-[85vh] flex p-5 lg:px-16 xl:px-28 items-center relative"
        style={{
          backgroundImage: "url(/home-hero.svg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="space-y-5 z-10">
          <BlurFade delay={0.25} inView>
            <div className="text-white text-2xl md:text-2xl transition-all duration-150 ease-out lg:text-5xl w-full max-w-5xl font-light relative z-10 px-2 lg:px-0">
              <div>EMPOWERING INDIA THROUGH</div>
              <div>CAPACITY BUILDING AND INNOVATION</div>
            </div>
            <div className="relative z-10 px-2 lg:px-0 pt-5">
              <p className="w-full text-sm md:text-base lg:text-lg z-10  text-white font-light max-w-lg">
                Driving progress with innovative solutions in training, skill
                development and technology to shape a brighter future.
              </p>
            </div>
          </BlurFade>
          <div
            className="absolute bottom-0 -z-[1] right-0 w-full h-[60vh] md:h-[65vh] lg:h-[75vh] bg-contain bg-right bg-no-repeat"
            style={{
              backgroundImage: "url('/home-hero-side.png')",
              backgroundPosition: "bottom right",
            }}
          />
        </div>
      </section>
      <section className="-mt-[6rem] lg:-mt-[5rem] xl:-mt-[6rem] w-full flex justify-center items-center px-5 sm:px-7 lg:px-16 xl:px-28 relative z-10">
        <Brands />
      </section>
      <BlurFade delay={0.25} inView>
        <section className="p-5 my-10 lg:mt-14 grid grid-cols-1 md:grid-cols-3  sm:px-10 md:px-0">
          <div className="flex flex-1 flex-col p-3 md:mb-10 lg:col-span-2 lg:mb-0 md:flex-row gap-5 sm:gap-10 justify-center items-center">
            <div className=" justify-center hidden lg:flex items-center w-56 md:w-64 xl:w-[18rem]">
              <img alt="" src="/dots.svg" className="w-full md:pl-10 lg:pl-0" />
            </div>
            <div className="flex justify-center items-center mb-8 md:mb-0 lg:mb-0 lg:b-0">
              <div className="text-4xl sm:text-4xl md:text-5xl lg:text-6xl lg:pl-4 max-w-sm h-full flex flex-col justify-between">
                <div>It's just</div>
                <div className="underline">the</div>
                <div className="underline">beginning</div>
                <div>of our</div>
                <div>journey!</div>
              </div>
            </div>
          </div>
          <div className="flex lg:justify-center xl:-ml-44 md:col-span-2 lg:col-span-1 justify-center lg:flex-1">
            <div className="flex flex-col gap-5 lg:ml-20">
              <div className="grid gap-5 h-full">
                <div className="pl-5 py-2 lg:py-3 lg:pl-7 rounded-l-full bg-gradient-to-r from-[#B5E0FA] to-[#CEEEE900] to-40%">
                  <div className="lg:text-lg xl:text-xl">300+</div>
                  <p className="text-xs text-[#10124E]">
                    Talented people from diverse cultures
                  </p>
                </div>
                <div className="pl-5 py-2 lg:py-3 lg:pl-7 rounded-full bg-gradient-to-r from-[#c1e7ff]  to-[#CEEEE900] to-50%">
                  <div className="lg:text-lg xl:text-xl">30+</div>
                  <p className="text-xs text-[#10124E]">
                    Projects established in 40+ cities{" "}
                  </p>
                </div>
                <div className="pl-5 py-2 lg:py-3 lg:pl-7 rounded-full bg-gradient-to-r from-[#B5E0FA]  to-[#CEEEE900] to-60%">
                  <div className="lg:text-lg xl:text-xl">1000+</div>
                  <p className="text-xs text-[#10124E]">
                    Happy clients using our services{" "}
                  </p>
                </div>
                <div className="pl-5 py-2 lg:py-3 lg:pl-7 rounded-full bg-gradient-to-r from-[#B5E0FA]  to-[#CEEEE900] to-70%">
                  <div className="lg:text-lg xl:text-xl">500,000+</div>
                  <p className="text-xs text-[#10124E] max-w-[16rem]">
                    Lives impacted with education and training
                    opportunities{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </BlurFade>
      {/* expertise and expertise section */}
      <BlurFade delay={0.25} inView>
        <section className="px-5 sm:px-10 lg:px-16 xl:px-28 pt-4">
          <ExpertiseAndExpericence />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="px-5 my-16 sm:px-10 lg:px-16 xl:mt-24 xl:px-28 xl:pr-12">
          <OurMisson />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="px-5 sm:px-10 lg:px-16 xl:px-28  my-10">
          <WorkwithUs />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section>
          <HomeMarquee />
        </section>
      </BlurFade>
      <section
        className="px-5 sm:px-10 mt-10"
        style={{
          backgroundImage: "url('/home/early-access-bg.svg')",
        }}
      >
        <EarlyAccess />
      </section>
    </div>
  );
};

export default HomePage;
